import React from 'react';
import { intlShape, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import randomstring from 'uuid/v4';

import { bindActionCreators } from 'redux';
import * as actions from '../../../../actions/api.form.actions';

import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

import { TypeVenueIcon } from '../../../../images/icons/WrapSvg';

import Task from './Task';

class Local extends React.Component {
    state = {
        valor: '',
        comment: '',
        point: 0,
        correction: 0,
        message: undefined,
        intervalId: undefined,
        desactivado: false,
    };

    static getDerivedStateFromProps(props, state) {
        const { data, parentDeactivated } = props;
        if (data !== state.data || parentDeactivated !== state.parentDeactivated) {
            state.valor = data.valor ? data.valor.includes('|') ? data.valor.split('|')[1] : data.valor : '';
            state.desactivado = data.desactivado;
            state.parentDeactivated = parentDeactivated;
            state.data = data;
            return state;
        }
        return null;
    }

    handleChange = (name) => (event) => {
        const valor = event.target.value;
        this.props.setValue(name, valor, '', false, {});
        this.setState({ valor: valor });
    };

    handleDeactive = (data, checked) => {
        this.props.setValue(data.codigo, undefined, '', checked, {});
        this.setState({ desactivado: checked, valor: '' });
    };

    render() {
        const { data, last, intl, editable, info, parentDeactivated } = this.props;
        const { valor, desactivado } = this.state;
        const nodes = info.security.locals
                        .sort((a, b) => a.name > b.name ? 1 : -1)
                        .reduce((arr, c) => {
                            if (c.leaf) {
                                if (
                                    info &&
                                    info.security &&
                                    info.security.localPermits &&
                                    info.security.localPermits[c.id] &&
                                    info.security.localPermits[c.id].some((f) => f === '57')
                                ) {
                                    arr.push(c);
                                }
                            }
                            return arr;
                        }, []);
        const component = (
            <FormControl className={'flex_full width100 barlow_italic c_slate'}>
                <InputLabel htmlFor="age-native-simple">
                    {intl.formatMessage({ id: 'options_field_label' })}
                </InputLabel>
                <Select
                    native
                    value={valor}
                    disabled={!this.props.editable || data.disabled || parentDeactivated}
                    onChange={this.handleChange(data.codigo)}
                    inputProps={{
                        name: data.codigo,
                        id: data.codigo,
                    }}
                >
                    <option key={randomstring()} value={undefined} />
                    {nodes &&
                        nodes.map((cat) => {
                            return (
                                <option key={randomstring()} value={cat.id}>
                                    {cat.name}
                                </option>
                            );
                        })}
                </Select>
            </FormControl>
        );
        return (
            <Task
                key={data.codigo}
                data={data}
                value={valor}
                desactivado={desactivado || parentDeactivated}
                editable={editable}
                icon={<TypeVenueIcon color="primary" />}
                text="type_label_local"
                last={last}
                component={component}
                parentDeactivated={parentDeactivated}
                onDeactive={this.handleDeactive}
            />
        );
    }
}

Local.propTypes = {
    intl: intlShape.isRequired,
};

const mapStateToProps = (state) => {
    return {
        info: state.info,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actions), dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(injectIntl(Local));



// WEBPACK FOOTER //
// ./src/components/complex/forms/types/Local.js